import React from 'react';

// hooks
import useUserLanguage from 'shared/hooks/useUserLanguage';

// styles
import StyledMarkdown from 'shared/StyledMarkdown';

// language
import en from 'appExplainers/translations/privacy/en';
import fr from 'appExplainers/translations/privacy/fr';

function Privacy(): JSX.Element {
  const language = useUserLanguage();
  const privacy = language === 'en' ? en : fr;

  return <StyledMarkdown content={privacy} />;
}

export default Privacy;
